import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  useSiteConfigStore,
  selectProductName,
} from "@/stores/siteConfigStore";
import { usePageTitle } from "@/hooks/usePageTitle";
import styles from "./Presentation.module.css";

// Constantes de módulo: guardam a chave, e o texto é resolvido no render.
const FEATURES = [
  { icon: "📊", key: "realtime" },
  { icon: "⚠️", key: "alarms" },
  { icon: "📈", key: "analytics" },
  { icon: "🗺️", key: "plants" },
  { icon: "🔧", key: "maintenance" },
  { icon: "📱", key: "responsive" },
];

const STATS = [
  { number: "250+",  labelKey: "presentation.stats.machines" },
  { number: "99.9%", labelKey: "presentation.stats.uptime" },
  { number: "24/7",  labelKey: "presentation.stats.continuous" },
  { number: "15+",   labelKey: "presentation.stats.plants" },
];

export default function Presentation() {
  const { t } = useTranslation();
  usePageTitle(t("presentation.pageTitle"));
  const productName = useSiteConfigStore(selectProductName);

  function scrollToFeatures() {
    document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <div className={styles.presentationPage}>
      {/* Hero */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <div className={styles.logo}>
            <div className={styles.logoIcon}>🏭</div>
            <h1>{productName}</h1>
          </div>
          <h2 className={styles.heroTitle}>{t("presentation.headline")}</h2>
          <p className={styles.heroDescription}>{t("presentation.subheadline")}</p>
          <div className={styles.heroActions}>
            <Link to="/auth/login" className={`${styles.btn} ${styles.btnPrimary}`}>
              {t("presentation.accessSystem")}
            </Link>
            <button
              type="button"
              className={`${styles.btn} ${styles.btnSecondary}`}
              onClick={scrollToFeatures}
            >
              {t("presentation.exploreFeatures")}
            </button>
          </div>
        </div>
      </section>

      {/* Features */}
      <section id="features" className={styles.features}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>{t("presentation.featuresTitle")}</h2>
          <div className={styles.featuresGrid}>
            {FEATURES.map((f) => (
              <div key={f.key} className={styles.featureCard}>
                <div className={styles.featureIcon}>{f.icon}</div>
                <h3>{t(`presentation.features.${f.key}.title`)}</h3>
                <p>{t(`presentation.features.${f.key}.description`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className={styles.stats}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>{t("presentation.statsTitle")}</h2>
          <div className={styles.statsGrid}>
            {STATS.map((s) => (
              <div key={s.labelKey} className={styles.statItem}>
                <div className={styles.statNumber}>{s.number}</div>
                <div className={styles.statLabel}>{t(s.labelKey)}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className={styles.cta}>
        <div className={styles.container}>
          <h2>{t("presentation.ctaTitle")}</h2>
          <p>{t("presentation.ctaText", { produto: productName })}</p>
          <Link
            to="/auth/login"
            className={`${styles.btn} ${styles.btnPrimary} ${styles.btnLarge}`}
          >
            {t("presentation.ctaButton")}
          </Link>
        </div>
      </section>
    </div>
  );
}
